import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from './partials/Header';
import ActionLink from './partials/ActionLink';
import { useFavorites } from './FavoritesContext';
import { getRecentSearch } from './utils/recentSearch';
import { getAgencyUrl } from './utils/agencyUrl';
import useAvailableAgencies from './utils/useAvailableAgencies';
import GoogleReviews from './agency/GoogleReviews';
import '../css/Results.css';

export default function Favorites() {
    const { favorites, removeFavorite, removeFavorites } = useFavorites();
    const { cards, loading, error, retry, unavailableIds } = useAvailableAgencies(favorites);
    const searchResultsLink = getRecentSearch() ? '/risultati' : '/#servizi-funebri';

    useEffect(() => { removeFavorites(unavailableIds); }, [unavailableIds, removeFavorites]);

    return <div className="ef-page ef-favorites-page">
        <Header />
        <main className="ef-favorites-content">
            <div className="ef-favorites-heading">
                <div>
                    <p className="ef-results-eyebrow">Le tue selezioni</p>
                    <h1>I miei preferiti</h1>
                    <p>Le agenzie che hai salvato, sempre a portata di mano.</p>
                </div>
                <Link className="ef-results-back-button" to={searchResultsLink}><span aria-hidden="true">←</span> Cerca altre agenzie</Link>
            </div>
            {loading ? <div className="ef-favorites-empty" role="status"><p>Verifica delle agenzie preferite in corso...</p></div>
                : error ? <div className="ef-favorites-empty" role="alert"><h2>Preferiti temporaneamente non disponibili</h2><p>Non è stato possibile verificare le agenzie salvate. Riprova tra qualche istante.</p><button type="button" className="ef-results-back-button" onClick={retry}>Riprova</button></div>
                : cards.length === 0 ? <div className="ef-favorites-empty">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z" /></svg>
                <h2>Non hai ancora preferiti</h2>
                <p>Cerca un'agenzia e tocca il cuore per salvarla qui.</p>
                <Link to="/#servizi-funebri">Trova un'agenzia <span aria-hidden="true">→</span></Link>
            </div> : <section className="ef-favorites-list" aria-label="Agenzie preferite">
                {cards.map(card => <article className="ef-favorite-card" key={card.publicId}>
                    <div className="ef-favorite-card__top">
                        <h2>{card.name || 'Agenzia salvata'}</h2>
                        <button type="button" className="ef-favorite-card__remove" onClick={() => removeFavorite(card.publicId)} aria-label={`Rimuovi ${card.name || 'l’agenzia'} dai preferiti`} title="Rimuovi dai preferiti">×</button>
                    </div>
                    <div className="ef-favorite-card__meta">
                        {card.location && <span>{card.location}</span>}
                        {card.since && <span>Dal {card.since}</span>}
                        {card.isFuneralHomeAvailable && <span className="ef-favorite-card__available">Casa funeraria disponibile</span>}
                    </div>
                    <GoogleReviews reviews={card.googleReviews} agencyId={card.publicId} source="favorites" compact />
                    <div className="ef-favorite-card__bottom">
                        <p>Consulta la scheda e contatta l’agenzia per informazioni.</p>
                        <div className="ef-favorite-card__actions">
                            {card.phone && <ActionLink action="call" agencyId={card.publicId} source="favorites" href={`tel:${card.phone}`} className="ef-favorite-card__call bg-primary">Chiama</ActionLink>}
                            <ActionLink action="info" agencyId={card.publicId} source="favorites" className="ef-favorite-card__details" to={getAgencyUrl(card.publicId)}>Vedi dettagli <span aria-hidden="true">→</span></ActionLink>
                        </div>
                    </div>
                </article>)}
            </section>}
        </main>
    </div>;
}
